import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Drawer,
  CircularProgress,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  Button,
  IconButton,
  Tooltip,
  Checkbox,
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore"; // Icon for Accordion
import CustomProgressBar from "app/utils/CustomProgressBar";
import axios from "axios";
import { Table } from "react-bootstrap";
import { toast } from "react-toastify";
// Added by Gauri for Approvers Progress bar on 22 Apr 2025
import ApproversProgressBar from "app/utils/ApproversProgressBar";
import AxiosInstance1 from "app/hooks/AxiosInstance/AxiosInstance1";

// Changed legends names by Gauri on 05 Feb 2025
const legends = [
  { color: "#81cf09", label: "Cleared" }, // Green
  { color: "#F5C330", label: "Current" }, // Yellow
  { color: "#f55c30", label: "Delayed current" }, // Orange
  { color: "#B3B3B3", label: "Not Started Yet" }, // Grey
];

{/* Added onRefresh prop by Gauri to trigger refresh in WorkflowForcePush on 04 Nov 2025 */}
const WorkflowApprovers = ({ data, data1, data2, initiativesID, onRefresh }) => {
  console.log("WorkflowApprovers data:", data);
  console.log("WorkflowApprovers data1 gauri11:", data1);
  console.log("WorkflowApprovers data2:", data2);

  const [cstageName, setCStageName] = useState("");
  const [dewdate, setDewdate] = useState("");
  const [drawerOpen1, setDrawerOpen1] = useState(false); // Drawer state
  const [loading, setLoading] = useState(false); // Loading state for API call
  const [workflowData, setWorkflowData] = useState(null); // Data for the drawer content
  const [selectedNOI, setSelectedNOI] = useState("");
  const accessToken = sessionStorage.getItem("access_token");
  const userdata = JSON.parse(sessionStorage.getItem("user"));
  const employeeId = userdata?.employeeId;
  const [selectedNOI1, setSelectedNOI1] = useState("");
  const [open, setOpen] = useState(false);
  const [allApproversData, setAllApproversData] = useState([]); // State for approvers data
  const [approversData, setApproversData] = useState([]); // State for approvers data
  const [selectedStage, setSelectedStage] = useState(null);
  const [selectedItems, setSelectedItems] = useState([]);

  // const handleStageClick = (stageId) => {
  //   const stageObj = data2.find(stage => stage.requestStageID === stageId);
  //   setSelectedStage(stageObj);
  //   setOpen(true);
  // };

  // const handleStageClick = (stage) => {
  //   const stageClicked = data2.find(
  //     (stages) => stages.requestStageID === stage
  //   );

  //   // Prevent drawer from opening if stage ID is 1 or 10
  //   if (!stageClicked || stageClicked.requestStageID === 1 || stageClicked.requestStageID === 10) {
  //     return;
  //   }

  //   setSelectedStage(stageClicked);
  //   console.log("Selected stage WorkflowApprovers:", selectedStage);
  //   setOpen(true); // open the Drawer
  // };
  const handleStageClick = (stage) => {
    const stageClicked = data2.find(
      (stages) => stages.requestStageID === stage
    );

    if (
      !stageClicked ||
      stageClicked.requestStageID === 1 ||
      stageClicked.requestStageID === 10 ||
      stageClicked.isStageApplicable === 0
    ) {
      return;
    }

    setSelectedStage(stageClicked);
    fetchAdditionalApprovers(stageClicked.requestStageID); // pass StageID here
    setOpen(true); // open the Drawer
  };

  useEffect(() => {
    if (selectedStage) {
      console.log("Selected stage WorkflowApprovers:", selectedStage);
    }
  }, [selectedStage]);

  const handleClick = async () => {
    setLoading(true);
    try {
      const response = await AxiosInstance1.get(
        `/api/ManageWorkFlow/GetManageWorkFlowChangeNOI?IdeaID=${initiativesID}&NOI=${selectedNOI1}`
        // {
        //   headers: {
        //     Authorization: `Bearer ${accessToken}`,
        //   },
        // }
      );
      const result = response?.data;
      setWorkflowData(result);
    } catch (error) {
      console.error("Error fetching workflow data:", error);
    } finally {
      setLoading(false);
    }
  };

  // const fetchAdditionalApprovers = async () => {
  //   const accessToken = sessionStorage.getItem("access_token"); // Get the access token
  //   const headers = {
  //     Authorization: `Bearer ${accessToken}`, // Set Authorization header
  //   };

  //   try {
  //     const response = await axios.get(
  //       `${window.runtimeConfig.REACT_APP_BASEURL_ACCESS_CONTROL1}/api/ManageWorkFlow/GetAdditionalApprovers?IdeaID=${initiativesID}`,
  //       { headers }
  //     );
  //     setAllApproversData(response?.data?.data); // Set the approvers data
  //     setApproversData(response.data.data.listAdditionalApproverRole);
  //     console.log(
  //       "fetchAdditionalApprovers API Response:",
  //       response.data.data.listAdditionalApproverRole
  //     ); // Log the API response
  //   } catch (error) {
  //     console.error("Error fetching stage configuration data:", error);
  //   }
  // };
  const fetchAdditionalApprovers = async (stageID) => {
    const accessToken = sessionStorage.getItem("access_token"); // Get the access token
    const headers = {
      Authorization: `Bearer ${accessToken}`, // Set Authorization header
    };

    try {
      const response = await AxiosInstance1.get(
        `/api/ManageWorkFlow/GetAdditionalApprovers?IdeaID=${initiativesID}&StageID=${stageID}`
        // { headers }
      );
      setAllApproversData(response?.data?.data); // Set the approvers data
      setApproversData(response.data.data.listAdditionalApproverRole);
      console.log(
        "fetchAdditionalApprovers API Response:",
        response.data.data.listAdditionalApproverRole
      ); // Log the API response
    } catch (error) {
      console.error("Error fetching stage configuration data:", error);
    }
  };

  useEffect(() => {
    fetchAdditionalApprovers();
  }, [initiativesID]);

  // Added by Gauri to save Additional Approver on 22 Apr 2025
  const handleSaveAdditionalApprover = async () => {
    // Extract StageID and NOIID from the API response
    // const stageID = allApproversData?.listAdditionalApproverINIDetails?.[0]?.requeststageID;
    const stageID = selectedStage.requestStageID;
    const noiID =
      allApproversData?.listAdditionalApproverINIDetails?.[0]?.natureofdemandID;

    const isCompletedCurrentStage = data2?.some(
      (stage) =>
        stage.requestStage === "Completed" && stage.isCurrentStage === 1
    );

    if (!selectedStage || !selectedStage.requestStageID) {
      toast.error("Please select a stage before saving.");
      return;
    }

    if (!noiID) {
      toast.error("NOIID is missing.");
      return;
    }

    if (isCompletedCurrentStage) {
      toast.error(
        "Initiative is on Roadmap stage. Hence you cannot add approvers."
      );
      return;
    }

    // Extract SelectedIDs and NotSelectedIDs based on user selections
    const selectedIDs = [];
    const notSelectedIDs = [];

    approversData.forEach((role) => {
      role.additionalApproverEmployeeList.forEach((employee) => {
        if (employee.isSelected === 1) {
          selectedIDs.push(employee.employeeID);
        } else {
          notSelectedIDs.push(employee.employeeID);
        }
      });
    });

    // Validate if there are any selected approvers
    if (selectedIDs.length === 0) {
      toast.error("Please select at least one approver.");
      return;
    }

    // Make the API call to save the data
    const accessToken = sessionStorage.getItem("access_token");
    const apiUrl = `/api/ManageWorkFlow/PostAdditionalApprovers?IdeaID=${initiativesID}&StageID=${stageID}&NOIID=${noiID}&SelectedIDs=${selectedIDs}&NotSelectedIDs=${notSelectedIDs}&UserID=${employeeId}`;

    try {
      const response = await AxiosInstance1.post(
        apiUrl,
        null, // No request body
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      toast.success("Additional approvers saved successfully!");
      console.log("API Response:", response.data);
      // Added by Gauri to refresh WorkflowForcePush data after save on 04 Nov 2025
      if (onRefresh) {
        onRefresh();
      }
    } catch (error) {
      console.error("Error saving additional approvers:", error);
      toast.error("An error occurred while saving additional approvers.");
    }

    // fetch(apiUrl, {
    //   method: "POST",
    //   headers: {
    //     "Content-Type": "application/json",
    //     Authorization: `Bearer ${accessToken}`,
    //   },
    // })
    //   .then((response) => {
    //     if (!response.ok) {
    //       throw new Error("Failed to save additional approvers.");
    //     }
    //     return response.json();
    //   })
    //   .then((data) => {
    //     toast.success("Additional approvers saved successfully!");
    //     console.log("API Response:", data);
    //   })
    //   .catch((error) => {
    //     console.error("Error saving additional approvers:", error);
    //     toast.error("An error occurred while saving additional approvers.");
    //   });
  };

  useEffect(() => {
    if (approversData?.length) {
      const initiallySelected = [];
      approversData.forEach((role) => {
        role.additionalApproverEmployeeList.forEach((emp) => {
          if (emp.isSelected === 1) {
            initiallySelected.push(emp.employeeID);
          }
        });
      });
      setSelectedItems(initiallySelected);
    }
  }, [approversData]);

  // const handleSelectItem = (event, employeeID) => {
  //   if (event.target.checked) {
  //     setSelectedItems((prev) => [...prev, employeeID]);
  //   } else {
  //     setSelectedItems((prev) => prev.filter((id) => id !== employeeID));
  //   }
  // };
  const handleSelectItem = (event, employeeID, roleID) => {
    setApproversData((prevApproversData) =>
      prevApproversData.map((role) => {
        if (role.roleID === roleID) {
          return {
            ...role,
            additionalApproverEmployeeList:
              role.additionalApproverEmployeeList.map((emp) => {
                if (emp.employeeID === employeeID) {
                  return {
                    ...emp,
                    isSelected: event.target.checked ? 1 : 0, // Update isSelected based on checkbox state
                  };
                }
                return emp;
              }),
          };
        }
        return role;
      })
    );
  };

  // Added by Gauri to reset checkboxes to original API response values on 23 Apr 2025
  const handleDrawerClose = () => {
    setOpen(false);
    const resetData = allApproversData?.listAdditionalApproverRole || [];
    setApproversData(JSON.parse(JSON.stringify(resetData))); // deep clone to reset state
  };

  useEffect(() => {
    handleClick();
  }, [selectedNOI1]);

  const renderTable = (data) => (
    <div className="table-responsive">
      <table className="table table-hover">
        <thead>
          <tr>
            <th>Order</th>
            <th>Stage</th>
            <th>Approvers</th>
          </tr>
        </thead>
        <tbody>
          {data?.map((item, index) => (
            <tr key={index}>
              <td>{item.orderNo}</td>
              <td>{item.requestStage}</td>
              <td>{item.stakeHolderNames}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );

  return (
    <div className="container-fluid" style={{ padding: "20px", backgroundColor: "#f9f9f9" }}>
      <Typography
        variant="subtitle1"
        sx={{ marginBottom: "20px", fontWeight: "bold" }}
      >
        2. Additional Approvers
      </Typography>
      <Typography variant="body1" sx={{ marginBottom: "20px" }}>
        If you need additional approvers,{" "}
        {/* Commented and added code by Gauri start here */}
        {/* <a
          href="#"
          onClick={handleClick}
          style={{ textDecoration: "underline", cursor: "pointer" }}
        >
          Click
        </a>{" "} */}
        {/* Commented and added code by Gauri start here */}
        Click on the Stage.
      </Typography>
      <div className="stages-div px-4 pt-3 mb-2" id="stages-div">
        <div className="stage-status d-flex justify-content-end align-items-center">
          <div className="stage-title">
            {/* Commented and Added section UI by Gauri start here on 04 Feb 2025 */}
            {/* <Typography variant="h6" style={{ fontSize: "11px" }}>
              Legends
            </Typography> */}
            <Box sx={{ fontWeight: "bold" }}>Legends:</Box>
            {/* Commented and Added section UI by Gauri end here on 04 Feb 2025 */}
          </div>

          <div className="stage-content d-flex align-items-center">
            {legends.map((legend, index) => (
              <div key={index} className="d-flex gap-1 ms-3">
                <div
                  style={{
                    width: "20px",
                    height: "20px",
                    backgroundColor: legend.color,
                    borderRadius: "4px",
                  }}
                ></div>
                <Typography variant="body1" style={{ fontSize: "12px" }}>
                  {legend.label}
                </Typography>
              </div>
            ))}
          </div>
        </div>
      </div>
      <ApproversProgressBar
        // passsed data2 for stages by Gauri on 05 Feb 2025
        stages={data2}
        setDewdate={setDewdate}
        setCStageName={setCStageName}
        percentageOfComplete={data1?.percentageOfComplete}
        noOfStageRemain={data1?.noOfStageRemain}
        initiative={data1}
        // onClick={() => setOpen(true)}
        onStageClick={handleStageClick}
      />

      {/* Drawer for displaying workflow details */}
      <Drawer
        anchor="right"
        open={drawerOpen1}
        onClose={() => setDrawerOpen1(false)}
      >
        <Box sx={{ width: 800, padding: 3 }}>
          {loading ? (
            <CircularProgress />
          ) : workflowData ? (
            <>
              <Typography variant="h5" sx={{ marginBottom: 2 }}>
                Nature of Initiative
              </Typography>
              <div className="details-div">
                <Typography variant="body2">
                  <strong>Initiative:</strong> Workflow Configure Initiative
                </Typography>
                <Typography variant="body2">
                  <strong>Nature of Initiative:</strong> Tool Implementation
                </Typography>
              </div>
              <div
                style={{
                  marginTop: "30px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <FormControl style={{ width: "200px" }}>
                  <InputLabel>Change Nature of Initiative</InputLabel>
                  <Select
                    label="Change Nature of Initiative"
                    value={selectedNOI1}
                    onChange={(e) => setSelectedNOI1(e.target.value)}
                    fullWidth
                  >
                    {data && data.length > 0 ? (
                      data.map((item) => (
                        <MenuItem
                          key={item.natureOfDemandID}
                          value={item.natureOfDemandID}
                        >
                          {item.natureOfDemand}
                        </MenuItem>
                      ))
                    ) : (
                      <MenuItem value="">No options available</MenuItem>
                    )}
                  </Select>
                </FormControl>
              </div>
              <Accordion defaultExpanded>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography>Changed Nature of Initiative Details1</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  {renderTable(workflowData?.data?.listManageWorkCurrentNOI)}
                </AccordionDetails>
              </Accordion>

              <Accordion>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography>Changed Nature of Initiative Details</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  {renderTable(workflowData?.data?.listManageWorkChangeNOINOI)}
                </AccordionDetails>
              </Accordion>
            </>
          ) : (
            <Typography>No data available</Typography>
          )}
        </Box>
      </Drawer>

      {/* Drawer for Workflow Approvers */}
      <Drawer
        anchor="right"
        open={open}
        // onClose={() => setOpen(false)}
        onClose={handleDrawerClose}
        PaperProps={{
          sx: { width: "60vw" },
        }}
      >
        <div style={{ padding: "20px" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: "20px",
              backgroundColor: "#f0f0f0", // Light grey background color
              padding: "10px", // Optional: add padding to ensure content doesn't touch the edges
              borderRadius: "4px", // Optional: add rounded corners for a smoother look
            }}
          >
            <Typography variant="h6">Initiative Approvers</Typography>
            <IconButton onClick={() => setOpen(false)}>
              <Tooltip title="Close">
                <CloseIcon />
              </Tooltip>
            </IconButton>
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            {/* {(data1?.noOfStageRemain = !1 || (<Button
              variant="contained"
              color="primary"
              onClick={handleSaveAdditionalApprover}
            >
              Save
            </Button>))} */}
            {data1?.noOfStageRemain !== 1 && (
              <Button
                variant="contained"
                color="primary"
                onClick={handleSaveAdditionalApprover}
              >
                Save
              </Button>
            )}
          </div>

          <Box sx={{ fontSize: "15px", marginBottom: 1 }}>
            Initiative Details -{" "}
          </Box>

          <div className="details-div mb-2">
            <Typography variant="body2">
              <strong>Initiative:</strong> {selectedStage?.title}
            </Typography>
            <Typography variant="body2">
              <strong>Nature of Initiative:</strong>{" "}
              {selectedStage?.natureofDemand}
            </Typography>
            <Typography variant="body2">
              <strong>Stage:</strong> {selectedStage?.requestStage}
            </Typography>
          </div>

          {/* Table for Workflow Approvers */}
          <Table bordered>
            <thead>
              <tr>
                <th>Role</th>
                <th>Approver</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {approversData?.map((role) => (
                <>
                  {/* Row for the Role Name with colspan */}
                  <tr key={`role-${role.roleID}`}>
                    <td colSpan="3" style={{ backgroundColor: "#f3f3f3" }}>
                      {role.roleDescription}
                    </td>
                  </tr>

                  {/* Rows for each approver under the role */}
                  {role.additionalApproverEmployeeList.map((emp) => (
                    <tr key={emp.employeeID}>
                      <td></td>
                      <td>{emp.userName}</td>
                      <td>
                        {/* <Checkbox
                        checked={selectedItems.includes(emp.employeeID)}
                        onChange={(e) => handleSelectItem(e, emp.employeeID)}
                        disabled={emp.isDisabled === 1}
                      /> */}
                        <Checkbox
                          checked={emp.isSelected === 1}
                          onChange={(e) =>
                            handleSelectItem(e, emp.employeeID, role.roleID)
                          }
                          disabled={emp.isDisabled === 1}
                        />
                      </td>
                    </tr>
                  ))}
                </>
              ))}
            </tbody>
          </Table>
        </div>
      </Drawer>
    </div>
  );
};

export default WorkflowApprovers;
